import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { firebase_auth } from '../firebase/firebaseConfig';
import { useNavigate } from 'react-router-dom';
import './AdminLogin.css';
import { trackEvent } from '../utils/analyticsUtils';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      // Iniciar sesión con Firebase
      const userCredential = await signInWithEmailAndPassword(firebase_auth, email, password);
      const user = userCredential.user;
      
      // Registrar evento de inicio de sesión exitoso
      trackEvent('admin_login', {
        method: 'email',
        user_id: user.uid
      });
      
      // Guardar en sessionStorage que el usuario está autenticado
      sessionStorage.setItem('adminAuthenticated', 'true');
      
      // Redirigir al panel de administración (ahora a la ruta raíz en el subdominio admin)
      navigate('/');
    } catch (error) {
      console.error('Error al iniciar sesión:', error);
      setError('Credenciales incorrectas. Por favor, inténtelo de nuevo.');
      
      // Registrar evento de inicio de sesión fallido
      trackEvent('login_error', {
        method: 'email',
        error_code: error.code || 'unknown_error',
        error_message: error.message || 'Error desconocido'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-card">
        <h2>Acceso Administrador</h2>
        
        {error && (
          <div className="login-error">
            {error}
          </div>
        )}
        
        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label htmlFor="email">Correo electrónico</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="username"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Contraseña</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
            />
          </div>
          
          <button 
            type="submit" 
            className="login-button"
            disabled={loading}
          >
            {loading ? 'Iniciando sesión...' : 'Iniciar sesión'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin; 